export function NoInvoiceBadge() {
  return (
    <span
      className="ml-1.5 inline-flex items-center gap-1 rounded border border-border bg-muted/40 px-1.5 py-0.5 text-[10px] font-medium text-brand-slate"
      title="Marked: no invoice available"
    >
      <span aria-hidden>🚫</span>
      No invoice
    </span>
  );
}
